import groq from 'groq';

export const BASE_ARTICLES_FILTER = groq`_type == "article"`;

export const ARTICLE_SELECTION_AND_ORDERING = groq`{
  _id,
  title,
  "slug": slug.current,
  featuredImage { asset-> },
  subtitle,
  _updatedAt,
} | order(_updatedAt desc)`;
